import { MessageSquare, Sparkles, Cookie, Dices, Music, Terminal, ShieldBan, Cake, MonitorPlay, Twitch, Image, LogOut, Gamepad2, LayoutDashboard, Mic2, Pickaxe, PersonStanding } from "lucide-react";
import { TOKEN_KEY } from "@/lib/api";

const NAV = [
  { id: "chat", label: "Live Chat", icon: MessageSquare },
  { id: "ai", label: "PancakeCupCake_", icon: Sparkles },
  { id: "gamehelp", label: "Game Help", icon: Gamepad2 },
  { id: "economy", label: "Economy", icon: Cookie },
  { id: "games", label: "Games", icon: Dices },
  { id: "music", label: "Music", icon: Music },
  { id: "sing", label: "Sing", icon: Mic2 },
  { id: "minecraft", label: "Minecraft", icon: Pickaxe },
  { id: "avatar", label: "Avatar", icon: PersonStanding },
  { id: "commands", label: "Commands", icon: Terminal },
  { id: "redeems", label: "Media Redeems", icon: Image },
  { id: "moderation", label: "Moderation", icon: ShieldBan },
  { id: "overlay", label: "OBS Overlay", icon: MonitorPlay },
  { id: "overlayedit", label: "Overlay Editor", icon: LayoutDashboard },
  { id: "twitch", label: "Connect Twitch", icon: Twitch },
];

export default function Sidebar({ section, setSection }) {
  return (
    <aside className="fixed left-0 top-0 h-full w-64 hidden md:flex flex-col bg-[#080808] border-r border-white/10 z-30">
      <div className="px-6 py-6 border-b border-white/10">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center pulse-ring">
            <Cake className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-heading font-800 leading-none tracking-tight">Sprinkle Pancake Bot</h1>
            <p className="text-[11px] text-muted-foreground mt-0.5">Twitch Control Center</p>
          </div>
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            data-testid={`nav-${id}`}
            onClick={() => setSection(id)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ${
              section === id
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-white/5"
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        ))}
      </nav>
      <div className="px-4 py-4 border-t border-white/10 space-y-3">
        <button
          onClick={() => { localStorage.removeItem(TOKEN_KEY); window.location.href = "/login"; }}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-white/5 transition-colors duration-200"
          data-testid="logout-button"
        >
          <LogOut className="w-4 h-4" /> Log out
        </button>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          Dashboard online
        </div>
      </div>
    </aside>
  );
}
